// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".data-migration-task-details-dialog.common-dialog[data-v-7d30ec1a] .el-dialog{width:var(--common-dialog-large-width)}.data-migration-task-details-dialog.common-dialog .el-descriptions[data-v-7d30ec1a]{margin-bottom:var(--base-size-24)}", ""]);
// Exports
module.exports = exports;
